let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kVi5E")).then(() => parcelRequire('fIzY1'));